<template>
    <div class="page">
        <van-nav-bar
                title="修改栏目"
                left-text="返回"
                left-arrow
                @click-left="onClickLeft"
        />
        <van-cell-group>
            <van-field
                    v-model="form.title"
                    required
                    clearable
                    label="栏目名称"
                    placeholder="请输入栏目名称"
            />
            <van-cell title="父级栏目" :value="form.parentName" class="cell-select"  @click="clickParent" required is-link/>

              <van-actionsheet
                v-model="showParent"
                :actions="actions"
                @select="onSelect"
              />


            <van-cell title="栏目类型" :value="form.typeName" class="cell-select"  @click="clickType" required/>
            <van-actionsheet
                    v-model="showType"
                    :actions="actionsType"
                    @select="onSelectType"
            />
            <van-cell title="栏目模块" :value="form.moduleName" class="cell-select"  @click="clickModule" required/>
            <van-actionsheet
                    v-model="showModule"
                    :actions="actionsModule"
                    @select="onSelectModule"
            />
            <van-field
                    v-model="form.sort_order"
                    clearable
                    label="排序"
                    placeholder="请输入排序"
            />

        </van-cell-group>
        <van-button type="danger" size="large" class="btn-save" @click="clickSave">保存</van-button>
    </div>
</template>

<script>
  import Cookies from 'js-cookie'
    import {CellGroup,Field,NavBar,Cell,ActionSheet,Button,Dialog,Picker,Popup} from 'vant'
    const citys = {
        '浙江': ['杭州', '宁波', '温州', '嘉兴', '湖州'],
        '福建': ['福州', '厦门', '莆田', '三明', '泉州']
    };
    export default {
        name: "edit",
        components:{
            [CellGroup.name]:CellGroup,
            [Field.name]:Field,
            [NavBar.name]:NavBar,
            [Cell.name]:Cell,
            [ActionSheet.name]:ActionSheet,
            [Button.name]:Button,
            [Dialog.name]:Dialog,
            [Picker.name]:Picker,
            [Popup.name]:Popup
        },
        data(){
            return {
                form:{
                    typeName:'请选择栏目类型',
                    moduleName:'请选择栏目模块',
                    parentName:'请选择父栏目'
                },
                showType:false,
                actionsType:[
                    {name: '单页面',id:1},
                    {name: '内部栏目',id:2},
                    {name: '外部链接',id:3}
                ],
                showModule:false,
                actionsModule:[
                    {name: '文章模块',id:1},
                    {name: '简介模块',id:2}
                ],
                navId:0,
                showParent:false,
                columns:[
                    {
                        values: Object.keys(citys),
                        className: 'column1'
                    },
                    {
                        values: citys['浙江'],
                        className: 'column2',
                        defaultIndex: 2
                    }
                ],
                actions:[]
            }
        },
        created(){
            this.navId = this.$route.query.id;
            if (this.navId != undefined){
                this.$http.get(this.apiUrl+'/v1/nav/view?navId='+this.navId).then(({data})=>{
                    this.form = data.result;
                    this.$http.get(this.apiUrl+'/v1/nav/parent-list?siteId='+data.result.site_id).then(({data})=>{
                        for (let i in data.result) {
                            data.result[i].name = data.result[i].title;
                        }
                        this.actionsParent = data.result;
                    })
                })
            }

        },
        methods:{
            onClickLeft(){
                this.$router.back();
            },
            onSelectType(item){
                this.form.typeName = item.name;
                this.form.type = item.id;
                this.showType = false;
            },
            clickType(){
                this.showType = true;
            },
            clickParent(){
                this.showParent = true;
                this.$http.get('/v1/nav/index',{params:{siteId:Cookies.get('siteId')}}).then(({data})=>{
                    if (data.errcode == 0){
                        var arr = [];
                        for (var i = 0;i<data.result.length;i++){
                            arr.push({name:data.result[i].title,id:data.result[i].nav_id});
                        }
                        this.actions = arr;
                    }
                })
            },
            onSelectModule(item){
                this.form.moduleName = item.name;
                this.form.module_id = item.id;
                this.showModule = false;
            },
            onSelectParent(item){
                this.form.parentName = item.name;
                this.form.parent_id = item.id;
                this.showModule = false;
            },
            clickModule(){
                this.showParent = true;
            },
            clickSave(){
                this.$http.post(this.apiUrl+'/v1/nav/save?navId='+this.navId,this.form).then(({data})=>{
                    if (data.errcode == 0) {
                        Dialog.alert({
                            message:data.msg
                        }).then(()=>{
                            this.$router.push('/mobile/nav/index')
                        })
                    }else {
                        Dialog.alert({
                            message:data.msg
                        })
                    }
                })
            },
            onChange(picker, values) {
                picker.setColumnValues(1, citys[values[0]]);
            },
            onSelect(item){
                this.showParent = false;
                this.form.parent_id = item.id;
            }
        }
    }
</script>

<style scoped>
    .page{
        background: #fff;
    }
    .cell-select >>> .van-cell__title{
        max-width: 90px;
    }
    .cell-select >>> .van-cell__value{
        text-align: left;
    }
    .btn-save{
        width: 90%;
        margin:20px auto;
        display: block;
        text-align: center;
    }

</style>
